var map = {
	"./de/general15/slide1.svg": 767075,
	"./en/general15/slide1.svg": 441775,
	"./es/general15/slide1.svg": 105228,
	"./fr/general15/slide1.svg": 323220,
	"./nl/general15/slide1.svg": 963906,
	"./pt/general15/slide1.svg": 67616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612043;